import { Form } from 'antd';
import { isNil } from 'lodash/fp';
import { isValidElement } from 'react';
import { type DisplayFieldProps } from '../../../components/fields/DisplayField';
import { ReplicateInputField, StyledTextFieldWrapper } from './shared';

const DisplayField = (props: DisplayFieldProps) => {
    const { label, value, disabled } = props;

    if (typeof value === 'string' || typeof value === 'number') {
        return (
            <Form.Item>
                <StyledTextFieldWrapper>
                    {label && <span slot="label">{label}</span>}
                    <input disabled={disabled} type="text" value={value} readOnly />
                </StyledTextFieldWrapper>
            </Form.Item>
        );
    }

    if (!isNil(value) && isValidElement(value)) {
        return (
            <Form.Item>
                <ReplicateInputField disabled={disabled} readOnly>
                    {label && <span className="label">{label}</span>}
                    <div>{value}</div>
                </ReplicateInputField>
            </Form.Item>
        );
    }

    return (
        <Form.Item>
            <StyledTextFieldWrapper>
                {label && <span slot="label">{label}</span>}
                <input disabled={disabled} type="text" readOnly />
            </StyledTextFieldWrapper>
        </Form.Item>
    );
};

export default DisplayField;
